import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Robot_Video1 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoRobot1 = () => {
  return (
    <>
      <ModalVideo
        id="robot-video-1"
        dataText={Robot_Video1}
        videoSrc="https://www.youtube.com/embed/UPf5g0z4PaI?si=BkW-xsCt8nnFWP7M"
        videoTitle="KUTER_STUDIO_AI_ROBOT_VIDEO_1"
      />
    </>
  );
};

export default ModalVideoRobot1;
